<!-- <div *ngIf="true" class="main_content">
    <div class="page_main_sec p-0">       
        <div class="selection_pg_main_sec selection-tree">  
            <div class="selection-bx-wrap">               

                <div class="bx wow zoomIn" data-wow-duration=".8s" data-wow-delay=".1s">                   
                    <div class="title-wrap bx-title">
                        <img src="/assets/img/tree-icon-dark.png" class="img-fluid">
                        <span>Projects</span>
                    </div>
                    <div class="bx-content">
                        <mat-tree #groupProjectTree [dataSource]="groupProjectDataSource" [treeControl]="treeControl">
                            <mat-tree-node (click)="onSelectProject(node)" *matTreeNodeDef="let node"  matTreeNodePadding>
                                <div class="mat-tree-node-wrp" [class.active]="node.Id==_commonService.selectedProject">
                                   
                                    <span class="tree-last-node">{{node.name}}
                                       
                                    </span>
                                </div>
                            </mat-tree-node>
                            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                                <div class="mat-tree-node-wrp">
                                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                        </mat-icon>
                                        {{node.name}}
                                    </button>
                                </div>
                            </mat-tree-node>
                        </mat-tree>
                    </div>
                </div>
                <div [class.d-none]="!hasProjectHierarchy" class="bx wow zoomIn bx-hierarchy" data-wow-duration=".8s"
                    data-wow-delay=".8s">
                    
                    <div class="title-wrap bx-title">
                        <img src="/assets/img/tree-icon-dark.png" class="img-fluid">
                        <span>Hierarchy</span>
                    </div>
                    <div class="bx-content">
                        <mat-tree #subGroupTree [dataSource]="subGroupDataSource" [treeControl]="treeControl">
                            <mat-tree-node (click)="bindRoles('subgroup',node)" *matTreeNodeDef="let node"
                                matTreeNodePadding>
                                <div class="mat-tree-node-wrp"
                                    [class.active]="node.Id==_commonService.selectedSubgroup">
                                  
                                    <span class="tree-last-node">{{node.name}}
                                    
                                    </span>
                                </div>
                            </mat-tree-node>
                            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                                <div class="mat-tree-node-wrp">
                                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                        </mat-icon>
                                        {{node.name}}
                                    </button>
                                </div>
                            </mat-tree-node>
                        </mat-tree>
                    </div>
                </div>
                <div class="bx wow zoomIn" data-wow-duration=".8s" data-wow-delay="1.6s">

                    <div class="icon_float_sec role_bg_img scale-transition scale-out">
                    
                    </div>
                    <div class="title-wrap bx-title">
                        <img src="/assets/img/role.png" class="img-fluid">
                        <span>Select Role to Continue</span>
                    </div>
                    <div class="bx-content">
                        <ul class="selection-list role-li">
                            <li [ngClass]="{'selected' : _commonService.selectedRole == role.roleId}"
                                *ngFor="let role of roleList" (click)="onSelectRole(role.roleId)">
                                <div class="selected-check">
                                    <img src="/assets/img/user-dark.png" alt="">
                                    <span>{{role.roleName}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div> 
 -->



<div class="pageContentSec">
    <div class="landingPageContent">
        <div class="ladningTopLayerBg"></div>
        <img class="themeImg landingImg" alt="Landing Image">
        <div class="selectionSec">
            <h2 class="selection">Choose from the below options to start managing your Ideas</h2>
            <div class="selectionInnerSec">
                <div class="selectionCard territoryCard">
                    <div class="selectionCardHeader">
                        <p>Project</p>
                        <!-- <div class="infoSec"><span class="bi bi-info-circle"
                                title="Lorem ipsum dolor sit amet, adipiscing elit"></span></div> -->
                    </div>
                    <div class="selectionCardBody">
                        <div>
                            <div class="territoryListSec">
                                <ul class="territoriesSec">
                                    <li *ngFor="let _projects of project_masterData" class="territoryList shadowBox">

                                        <!-- <div  (click)="onSelectProject_new_design(_projects)" class="formRow"> -->
                                        <div (click)="onSelectProject_new_design(_projects)" class="formRow">
                                            <h4 class="radioButton">
                                                <input id="{{_projects.project_id}}"
                                                    checked="(_projects.project_id==_commonService.selectedProject) ? true: false"
                                                    type="radio" name="territoriesRadio">
                                                <!-- <input id="{{_projects.project_id}}" type="radio" name="territoriesRadio"> -->
                                                <label class="body"
                                                    for="{{_projects.project_id}}">{{_projects.project_name}}</label>
                                            </h4>
                                        </div>
                                    </li>
                                    <!-- <li class="territoryList shadowBox">
                            <div class="formRow">
                                <h4 class="radioButton">
                                    <input id="territory1" type="radio" name="territoriesRadio">
                                    <label class="body" for="territory1">Project 2</label>
                                </h4>
                            </div>
                        </li>
                        <li class="territoryList shadowBox">
                            <div class="formRow">
                                <h4 class="radioButton">
                                    <input id="territory2" type="radio" name="territoriesRadio">
                                    <label class="body" for="territory2">Project 3</label>
                                </h4>
                            </div>
                        </li>
                        <li class="territoryList shadowBox">
                            <div class="formRow">
                                <h4 class="radioButton">
                                    <input id="territory3" type="radio" name="territoriesRadio">
                                    <label class="body" for="territory3">Project 4</label>
                                </h4>
                            </div>
                        </li>
                        <li class="territoryList shadowBox">
                            <div class="formRow">
                                <h4 class="radioButton">
                                    <input id="territory4" type="radio" name="territoriesRadio">
                                    <label class="body" for="territory4">Project 5</label>
                                </h4>
                            </div>
                        </li>
                        <li class="territoryList shadowBox">
                            <div class="formRow">
                                <h4 class="radioButton">
                                    <input id="territory5" type="radio" name="territoriesRadio">
                                    <label class="body" for="territory5">Project 6</label>
                                </h4>
                            </div>
                        </li>
                         -->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="selectionCard roleCard">
                    <div class="selectionCardHeader">
                        <p>Roles</p>
                        <!-- <div class="infoSec"><span class="bi bi-info-circle"
                                title="Lorem ipsum dolor sit amet, adipiscing elit"></span></div> -->
                    </div>
                    <div class="selectionCardBody">
                        <div class="territoryListSec">
                            <ul class="territoriesSec">
                                <li *ngFor="let role of roleList" class="territoryList shadowBox"
                                    (click)="onSelectRole_new_design(role)">
                                    <div class="formRow">
                                        <h4 class="radioButton">
                                            <input id="{{role.roleId}}" type="radio"
                                                checked="(role.roleId==_commonService.selectedRole)? true: false"
                                                name="rolesRadio" [(ngModel)]="exitingRole_id" value="{{role.roleId}}">
                                            <!-- <input id="{{role.roleId}}"  type="radio" name="rolesRadio" value="{{role.roleId}}"> -->
                                            <label class="body" for="{{role.roleId}}">{{role.roleName}}</label>
                                        </h4>
                                    </div>
                                </li>
                                <!-- <li class="territoryList shadowBox">
                            <div class="formRow">
                                <h4 class="radioButton">
                                    <input id="roles1" type="radio" name="rolesRadio">
                                    <label class="body" for="roles1">QC Processor</label>
                                </h4>
                            </div>
                        </li>
                        <li class="territoryList shadowBox">
                            <div class="formRow">
                                <h4 class="radioButton">
                                    <input id="roles2" type="radio" name="rolesRadio">
                                    <label class="body" for="roles2">Admin</label>
                                </h4>
                            </div>
                        </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="selectedSec">
            <h1 class="secTitle">Your Selection</h1>
            <div class="scrollbar-Section">
                <div class="selectedDetailsSec">
                    <div class="selectedDetails">
                        <p class="labelTitle">Project</p>
                        <div class="detailWithFlag">
                            <p class="selectedContent">{{project_name}}</p>
                        </div>
                    </div>
                    <div class="selectedDetails">
                        <p class="labelTitle">Role</p>
                        <p class="selectedContent">{{role_name !=''?role_name:existing_role_name}}</p>
                    </div>
                </div>
                <div class="summarySec">
                    <p class="labelTitle">Idea Generation</p>

                    <div *ngFor="let idea of max_idealist" class="summarList orangeType">
                        <div *ngIf="idea.name!='' ? true: false;" class="summarDetails">
                            <p class="statusName">{{idea.name}}</p>
                            <!-- <p class="statusType">Dummy</p> -->
                        </div>
                        <p *ngIf="idea.name!='' ? true: false;" class="summaryCount">{{idea.values}} </p>

                        <div *ngIf="idea.name=='' ? true: false;" class="summarDetails">
                            <p>{{idea.values}}</p>
                            <!-- <p class="statusType">Dummy</p> -->
                        </div>

                    </div>
                    <!--summarList blueType <div class="summarList greyType">
                <div class="summarDetails">
                    <p class="statusName">Winning Idea</p>
                    <p class="statusType">Domain / eMails (Daily)</p>
                </div>
                <p class="summaryCount">29 </p>
            </div>
            <div class="summarList orangeType">
                <div class="summarDetails">
                    <p class="statusName">Total Idea for Month</p>
                    <p class="statusType">Touched by users</p>
                </div>
                <p class="summaryCount">100 </p>
            </div>
            <div class="summarList redType">
                <div class="summarDetails">
                    <p class="statusName">Max Total</p>
                    <p class="statusType">Trashed by users (Daily)</p>
                </div>
                <p class="summaryCount">100 </p>
            </div> -->
                </div>
            </div>
            <div class="selectedBtmBtn">
                <div class="formRow">
                    <button class="btnIconLt" (click)="onProceed_new_design()"><span>Proceed</span></button>
                </div>
            </div>

        </div>
    </div>
</div>



<div *ngIf="true" class="main_content">
    <div class="page_main_sec p-0">
        <div class="selection_pg_main_sec selection-tree">
            <div class="selection-bx-wrap">
                <div class="bx wow zoomIn" data-wow-duration=".8s" data-wow-delay=".1s">
                    <!-- <div class="icon_float_sec proj_bg_img scale-transition scale-out">
                        <img src="/assets/img/project_main.png" alt="">
                    </div> -->
                    <div class="title-wrap bx-title">
                        <img src="/assets/img/tree-icon-dark.png" alt="Tree Image" class="img-fluid">
                        <span>Projects</span>
                    </div>
                    <div class="bx-content">
                        <mat-tree [attr.role]="null" #groupProjectTree [dataSource]="groupProjectDataSource" [treeControl]="treeControl">
                            <mat-tree-node (click)="onSelectProject(node)" *matTreeNodeDef="let node"
                                matTreeNodePadding>
                                <div class="mat-tree-node-wrp" [class.active]="node.Id==_commonService.selectedProject">
                                    <!-- <button mat-icon-button disabled></button> -->
                                    <span class="tree-last-node">{{node.name}}
                                        <!-- <i class="fa fa-angle-double-right"></i> -->
                                    </span>
                                </div>
                            </mat-tree-node>
                            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                                <div class="mat-tree-node-wrp">
                                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                        </mat-icon>
                                        {{node.name}}
                                    </button>
                                </div>
                            </mat-tree-node>
                        </mat-tree>
                    </div>
                </div>
                <div [class.d-none]="!hasProjectHierarchy" class="bx wow zoomIn bx-hierarchy" data-wow-duration=".8s"
                    data-wow-delay=".8s">
                    <!-- <div class="icon_float_sec teritory_bg_img scale-transition scale-out">
                        <img src="/assets/img/map.svg" alt="">
                    </div> -->
                    <div class="title-wrap bx-title">
                        <img src="/assets/img/tree-icon-dark.png" alt="Tree Image" class="img-fluid">
                        <span>Hierarchy</span>
                    </div>
                    <div class="bx-content">
                        <mat-tree #subGroupTree  [attr.role]="null" [dataSource]="subGroupDataSource" [treeControl]="treeControl">
                            <mat-tree-node (click)="bindRoles('subgroup',node)" *matTreeNodeDef="let node"
                                matTreeNodePadding>
                                <div class="mat-tree-node-wrp"
                                    [class.active]="node.Id==_commonService.selectedSubgroup">
                                    <!-- <button mat-icon-button disabled></button> -->
                                    <span class="tree-last-node">{{node.name}}
                                        <!-- <i class="fa fa-angle-double-right"></i> -->
                                    </span>
                                </div>
                            </mat-tree-node>
                            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                                <div class="mat-tree-node-wrp">
                                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                        </mat-icon>
                                        {{node.name}}
                                    </button>
                                </div>
                            </mat-tree-node>
                        </mat-tree>
                    </div>
                </div>
                <div class="bx wow zoomIn" data-wow-duration=".8s" data-wow-delay="1.6s">

                    <div class="icon_float_sec role_bg_img scale-transition scale-out">
                        <!-- <img src="/assets/img/administrator.svg" alt=""> -->
                    </div>
                    <div class="title-wrap bx-title">
                        <img src="/assets/img/role.png" alt="Select Role" class="img-fluid">
                        <span>Select Role to Continue</span>
                    </div>
                    <div class="bx-content">
                        <ul class="selection-list role-li">
                            <li [ngClass]="{'selected' : _commonService.selectedRole == role.roleId}"
                                *ngFor="let role of roleList" (click)="onSelectRole(role.roleId)">
                                <div class="selected-check">
                                    <img src="/assets/img/user-dark.png" alt="Role Name">
                                    <span>{{role.roleName}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>